export const identity = (a) => a;

export const noop = () => {};
